import { DisplayObject } from '@pixi/display';

/**
 * Renders the object using the Canvas renderer
 *
 * @param {PIXI.CanvasRenderer} renderer - The renderer
 */
DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
{
    // OVERWRITE;
};
